import { APP_BUNDLES, EXAM_TITLES, BUNDLE_APP_NAME, IS_BUNDLE_APP, PAYWALL_COPY } from './_shared/brand-data'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_CISM,
  PRACTICE_TEST as PRACTICE_TEST_CISM,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_CISM,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_CISM,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_CISM,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_CISM,
} from './cism'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_CISA,
  PRACTICE_TEST as PRACTICE_TEST_CISA,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_CISA,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_CISA,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_CISA,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_CISA,
} from './cisa'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_CRISC,
  PRACTICE_TEST as PRACTICE_TEST_CRISC,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_CRISC,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_CRISC,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_CRISC,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_CRISC,
} from './crisc'
import {
  APP_DOMAIN_LIST as APP_DOMAIN_LIST_CDPSE,
  PRACTICE_TEST as PRACTICE_TEST_CDPSE,
  GET_STUDY_QUESTION_MENU as GET_STUDY_QUESTION_MENU_CDPSE,
  GET_FLASH_CARD_MENU as GET_FLASH_CARD_MENU_CDPSE,
  QUESTION_VERSION_OF_JSON as QUESTION_VERSION_OF_JSON_CDPSE,
  GET_ARTICLE_MENU as GET_ARTICLE_MENU_CDPSE,
} from './cdpse'

import { IMAGES } from "../lzapp_web_common_code/assets";
import { USER_DEAFULT_KEY } from "../lzapp_web_common_code/constant/event";

export { APP_BUNDLES, BUNDLE_APP_NAME, IS_BUNDLE_APP, PAYWALL_COPY }

export const APP_DATA = {
  DISPLAY_APP_NAME: 'CISA, CISM, CRISC, CDPSE ISACA Cert Prep',
};

export const GET_APP_NAME = (SELECTED_BUNDLE) => {
  return EXAM_TITLES[SELECTED_BUNDLE] || 'CISA';
};

export const GET_EXAM_DISPLAY_TITLE = (SELECTED_BUNDLE) => {
  return EXAM_TITLES[SELECTED_BUNDLE] || 'CISA';
};

const APP_NAME = "ISACA";

export const GET_APP_NAME_FOR_COLLECTION = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  const bundle = APP_BUNDLES.find(b => b.key === result);
  return bundle ? bundle.bundle_firebase_collection_name : 'CISA';
};

const QUESTION_VERSIONS = {
  'cisa': QUESTION_VERSION_OF_JSON_CISA,
  'cism': QUESTION_VERSION_OF_JSON_CISM,
  'crisc': QUESTION_VERSION_OF_JSON_CRISC,
  'cdpse': QUESTION_VERSION_OF_JSON_CDPSE
};

export const GET_QUESTION_VERSION_OF_JSON = async () => {
  const result = localStorage.getItem(USER_DEAFULT_KEY.SAVED_BUNDLE_DETAILS);
  return QUESTION_VERSIONS[result] || QUESTION_VERSION_OF_JSON_CISA;
};

export const app_url = "https://www.learnzapp.com/apps/isaca";

const PRACTICE_TESTS = {
  'cisa': PRACTICE_TEST_CISA,
  'cism': PRACTICE_TEST_CISM,
  'crisc': PRACTICE_TEST_CRISC,
  'cdpse': PRACTICE_TEST_CDPSE
};

export const GET_PRACTICE_TEST = (SELECTED_BUNDLE) => {
  return PRACTICE_TESTS[SELECTED_BUNDLE] || PRACTICE_TEST_CISA;
};

const DOMAIN_LISTS = {
  'cisa': APP_DOMAIN_LIST_CISA,
  'cism': APP_DOMAIN_LIST_CISM,
  'crisc': APP_DOMAIN_LIST_CRISC,
  'cdpse': APP_DOMAIN_LIST_CDPSE
};

export const GET_APP_DOMAIN_LIST = (SELECTED_BUNDLE) => {
  return DOMAIN_LISTS[SELECTED_BUNDLE] || APP_DOMAIN_LIST_CISA;
};

const STUDY_QUESTION_MENUS = {
  'cisa': GET_STUDY_QUESTION_MENU_CISA,
  'cism': GET_STUDY_QUESTION_MENU_CISM,
  'crisc': GET_STUDY_QUESTION_MENU_CRISC,
  'cdpse': GET_STUDY_QUESTION_MENU_CDPSE
};

export const GET_STUDY_QUESTION_MENU = (SELECTED_BUNDLE) => {
  const menuFn = STUDY_QUESTION_MENUS[SELECTED_BUNDLE] || GET_STUDY_QUESTION_MENU_CISA;
  let menu = menuFn();

  // Append testing mode menu item if IS_TEST_MODE is true
  if (IS_TEST_MODE) {
    menu.push({
      title: 'All Questions (Testing)',
      key: 'all_questions_testing',
      image: IMAGES?.ic_flash_topic,
      menu: null,
      requires_subscription: false
    });
  }

  return menu;
};

const FLASH_CARD_MENUS = {
  'cisa': GET_FLASH_CARD_MENU_CISA,
  'cism': GET_FLASH_CARD_MENU_CISM,
  'crisc': GET_FLASH_CARD_MENU_CRISC,
  'cdpse': GET_FLASH_CARD_MENU_CDPSE
};

export const GET_FLASH_CARD_MENU = (SELECTED_BUNDLE) => {
  const menuFn = FLASH_CARD_MENUS[SELECTED_BUNDLE] || GET_FLASH_CARD_MENU_CISA;
  return menuFn();
};

const ARTICLE_MENUS = {
  'cisa': GET_ARTICLE_MENU_CISA,
  'cism': GET_ARTICLE_MENU_CISM,
  'crisc': GET_ARTICLE_MENU_CRISC,
  'cdpse': GET_ARTICLE_MENU_CDPSE
};

export const GET_ARTICLE_MENU = (SELECTED_BUNDLE) => {
  const menuFn = ARTICLE_MENUS[SELECTED_BUNDLE] || GET_ARTICLE_MENU_CISA;
  let menu = [...menuFn()]; // Create a new array to avoid mutation

  // Append testing mode menu item if IS_TEST_MODE is true
  if (IS_TEST_MODE) {
    menu.push({
      title: 'All Articles (Testing)',
      key: 'all_articles_testing',
      image: IMAGES?.ic_flash_topic,
      menu: null,
      requires_subscription: false
    });
  }

  return menu;
};

/*** LEADING SCREEN TUTORIAL ARRAY ***/
export const GET_TUTORIALS = () => {
  return [
    {
      title: `ISACA CISA, CISM, CRISC & CDPSE Exam Prep`,
      image: IMAGES.slide_1,
      description:
        'Ace your exam on the first try with this comprehensive study app! \nPractice questions and flashcards to help you succeed in ISACA exams CISA, CISM, CRISC and CDPSE',
    },
    {
      title: "Readiness Score",
      image: IMAGES.slide_2,
      description:
        "The readiness score in the app provides a quick and easy way for you to assess your level of preparedness for the real exam, and to identify areas where you need to focus your study efforts in order to improve their chances of success.",
    },
    {
      title: "Practice makes Perfect!!",
      image: IMAGES.slide_3,
      description:
        "Create your own custom tests by choosing the topics and the number of questions or take pre-built practice tests and mock exams. \nThe custom test engine creates personalized tests with new and your weakest questions.",
    },
    {
      title: "Track your Progress",
      image: IMAGES.slide_4,
      description:
        "Keep track of your progress through the study materials and see how much you have left to complete. \nView the history of your completed tests and re-take any of them as needed.",
    },
    {
      title: "Available on-the-go",
      image: IMAGES.slide_5,
      description:
        "The app is available on both iOS and Android devices, so you study anywhere, anytime. \nYou can seamlessly access and work with your data across multiple devices.",
    },
  ];
};

/** STRINGS */
export const STRING = {
  share_message:
    "Hey there, I am using this app to prepare for CISA, CISM, CRISC and CDPSE certification exams. I think you will find it very useful. Check it out " +
    app_url,
};

export const THIRD_PARTY_CONFIG = {
  STRIPE_PRODUCT_ID: process.env.REACT_APP_STRIPE_PRODUCT_ID,
};

// Display name for the Stripe product on user-facing invoices.
// Each brand build sets its own value (matches the product name in the Stripe dashboard).
export const STRIPE_PRODUCT_DISPLAY_NAME = 'ISACA App - CISA, CISM, CRISC and CDPSE Exam Prep';

export const PAYWALL_COLUMNS = null;
export const IS_TEST_MODE = false;
export const IS_VISIBLE_COMMUNITY = true;

// Home smart-nudge continuation card — enabled for the ISACA bundle (all exams).
export const NUDGE_CARD_ENABLED = true;

// Metered article unlocks — 5 permanent unlocks per DAY (any domain, UTC
// midnight reset) for free users, replacing the legacy
// first-num_articles-per-domain cap. See docs/ARTICLES_METERING_GUIDE.md.
export const METERED_ARTICLE_UNLOCKS = 5;
export const METERED_ARTICLE_PERIOD = 'day';

// Post-sign-in welcome modal title (web twin of mobile WELCOME_DETAILS.welcomeModalTitle;
// title matches the mobile brand config so the greeting is identical cross-platform).
export const WELCOME_DETAILS = {
    welcomeModalTitle: 'Welcome to ISACA Prep!',
};
